import { useState } from 'react';

export const useActiveOption = () => {
  const [activeOption, setActiveOption] = useState('Display');

  return { activeOption, setActiveOption };
};
